import { useMemo, useState } from 'react'
import s from '../../../../commonStyles.modules.scss'
import { Table } from 'components/core-ui/Table'
import { makeCoreGetFileRequest, makeCoreGetRequest } from "utils/api"
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { useNotification } from 'hooks'
import { formatErrorMessage } from 'utils/formatting'
import { getColumns, toolbarActions } from "./helpers"
import { toTableRowItems } from './serializers'
import { formatAndDownloadResponse } from "../../../../../../utils/helpers"
import { useLocation } from "react-router-dom"

const BalancePackagingHistory = () => {
  const [tableItems, setTableItems] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isCSVExportLoading, setIsCSVExportLoading] = useState<boolean>(false)

  const { state } = useLocation() as {
    state?: {
      shopCode: string | number
      supplierCode: string | number
      dsSupportTypeId: string | number
    }
  }

  const { showNotification } = useNotification()
  const columns = useMemo(() => getColumns(), [])

  const baseFilters = useMemo(() => {
    if (!state) return []

    const { shopCode, supplierCode, dsSupportTypeId } = state

    return [
      { name: 'shopCode', value: shopCode != null ? JSON.stringify([shopCode]) : undefined },
      { name: 'supplierCode', value: supplierCode != null ? JSON.stringify([supplierCode]) : undefined },
      { name: 'dsSupportTypeId', value: dsSupportTypeId != null ? JSON.stringify([dsSupportTypeId]) : undefined },
    ]
  }, [state])

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)

    const filtersWithPackage = [
      ...(tableFilters ?? []),
      ...baseFilters
    ]

    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: `/shop-reception/ds-support-stock-inventory`,
          tableFilters: filtersWithPackage,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.list))
      setTotalCount(response.page.totalCount)

      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor din tabel. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const exportFileCSV = async (tableState) => {
    setIsCSVExportLoading(true)
    const { filters, order, orderBy } = tableState

    const filtersWithPackage = [
      ...(filters ?? []),
      ...baseFilters
    ]

    const url = toTableGETUrl({
      url: '/shop-reception/ds-support-stock-inventory/export',
      tableFilters: filtersWithPackage,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response)
      setIsCSVExportLoading(false)
    } catch (error) {
      setIsCSVExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(() => toolbarActions({
    exportFileCSV: exportFileCSV,
    isCSVExportLoading }),
  [isCSVExportLoading])

  return (
    <div className={s.mainContainer}>
      <Table
        hideCheckbox
        columns={columns}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        toolbarActions={toolbar}
        totalCount={totalCount}
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default BalancePackagingHistory
